// 动态引导
DynamicGuideLogic = xClass("DynamicGuideLogic")
DynamicGuideLogic.GUIDE_TYPE = {
    MERGER_BIRD: 1,
    SWAP_5X4:2,
    SWAP_4X4:3,
}
const GUIDE_TYPE = DynamicGuideLogic.GUIDE_TYPE
var instance = null;
DynamicGuideLogic.getInstance = function () {
    if (!instance) {
        instance = DynamicGuideLogic.new();
    }
    return instance
}
DynamicGuideLogic.prototype.ctor = function () {
    this.init()
}
DynamicGuideLogic.prototype.init = function () {
    let userLabel = UserManager.getInstance().userLabel
    this.info = {}
    // 统计行为数据
    this.info.effectCombineNum = {
    }
    // 引导数据
    this.info.dynamicGuideNum = {
    }

    for (const key in userLabel.effectCombineNum) {
        if (userLabel.effectCombineNum[key]) this.info.effectCombineNum[key] = userLabel.effectCombineNum[key]
    }
    for (const key in userLabel.dynamicGuideNum) {
        if (userLabel.dynamicGuideNum[key]) this.info.dynamicGuideNum[key] = userLabel.dynamicGuideNum[key]
    }
    this.dynamicGuideFlag = userLabel.dynamicGuideFlag || false
    cc.log("[DynamicGuide] init ",this.info ,this.dynamicGuideFlag)
}
DynamicGuideLogic.prototype.isOpen = function () {
    let level = UserManager.getInstance().user.topLevelId
    let dynamic_guide_limit = MetaManager.getGameCfg().dynamic_guide_limit || 500
    cc.log("[DynamicGuide] isOpen ",dynamic_guide_limit,level)
    return level < dynamic_guide_limit && this.dynamicGuideFlag
}

// 引导是否全部完成
DynamicGuideLogic.prototype.isAllComplete = function () {
    let self = this
    // 检查配置项中引导是否都完成
    for (const key in self.use_config) {
        let conf = self.use_config[key]
        if (!this.info.dynamicGuideNum[conf.guide_id] || this.info.dynamicGuideNum[conf.guide_id] <= 0){
            return false
        }
    }
    return true
}

DynamicGuideLogic.prototype.loadConfig = function () {
    let self = this
    if (!self.config) {
        return new Promise((resolve, reject) => {
            CfgManager.load("dynamic_guide").then(() => {
                self.config = CfgManager.get("dynamic_guide")
                CfgManager.release("dynamic_guide")
                cc.log("[DynamicGuide] self.config ", self.config)
                resolve();
            }).catch(() => reject())
        });
    } else
        return Promise.resolve();
}
DynamicGuideLogic.prototype.loadCube = function () {
    let self = this
    self.cubeGroup = UserManager.getInstance().getLevelGroup()
    return Promise.resolve();
}
DynamicGuideLogic.prototype.loadNeed = function () {
    let self = this
    if (!self.isOpen() || (self.config && self.cubeGroup)) {
        cc.log("[DynamicGuide] 无需加载 或 配置相关初始化完毕 无需重新加载")
        return Promise.resolve()
    }
    return Promise.all([self.loadConfig(), self.loadCube()])
}

DynamicGuideLogic.prototype.initUseConfig = function () {
    let self = this
    let cubeGroup = self.cubeGroup
    if (!self.use_config) {
        self.use_config = {}
        for (const key in self.config) {
            let conf = self.config[key]
            if (cubeGroup == conf.test_switch) {
                self.use_config[conf.guide_id] = conf
                self.use_config[conf.guide_id].levelTag = conf.level_tag.split(",")
                self.use_config[conf.guide_id].rangeTag = conf.range_tag.split(",")
                self.use_config[conf.guide_id].moveTag = conf.move_tag.split(",")

            }
        }
        cc.log("[DynamicGuide] self.use_config", self.use_config)
        this.allCompleteTag = this.isAllComplete()// 引导全部做完标签
        cc.log("[DynamicGuide] self.allCompleteTag", self.allCompleteTag)

    }
}
// 获取上传数据 (不符合条件返回{})
DynamicGuideLogic.prototype.getUploadData = function (mainLogic) {
    let self = this
    // self.use_config.rangeTag
    let data = {}
    if (!mainLogic.level) return data
    for (const key in self.use_config) {
        let conf = self.use_config[key]
        if (mainLogic.level >= conf.rangeTag[0] && mainLogic.level <= conf.rangeTag[1]) {
            if (!data.effectCombineNum) data.effectCombineNum = {}
            data.effectCombineNum[conf.guide_id] = self.getNumByGuideType(conf.guide_type, mainLogic)
            // 同时更新本地信息
            if (!this.info.effectCombineNum[conf.guide_id]) this.info.effectCombineNum[conf.guide_id] = 0
            this.info.effectCombineNum[conf.guide_id] += data.effectCombineNum[conf.guide_id]
        }else{
            cc.log(`[DynamicGuide] 统计${key}不在等级段`,conf.rangeTag)
        }
    }
    // 引导相关
    if (mainLogic.dynamicGuideList){
        for (const key in mainLogic.dynamicGuideList) {
            if (!data.dynamicGuideNum) data.dynamicGuideNum = {}
            data.dynamicGuideNum[key] = mainLogic.dynamicGuideList[key]
            if (!this.info.dynamicGuideNum[key]) this.info.dynamicGuideNum[key] = 0
            this.info.dynamicGuideNum[key] += data.dynamicGuideNum[key]
        }
    }
    cc.log("[DynamicGuide] getUploadData mainLogic.swapMergerListD ", mainLogic.swapMergerListD)
    cc.log("[DynamicGuide] getUploadData mainLogic.swapSpecialItemList ", mainLogic.swapSpecialItemList)
    cc.log("[DynamicGuide] getUploadData ", data)
    cc.log("[DynamicGuide] getUploadData this.info ", this.info)
    return data

}
DynamicGuideLogic.prototype.getNumByGuideType = function (guide_type, mainLogic) {
    let num = 0
    if (guide_type == GUIDE_TYPE.MERGER_BIRD) {
        if (mainLogic.swapMergerListD){
            num = mainLogic.swapMergerListD[AnimalTypeConfig.kColor]
            num += mainLogic.swapMergerListD[AnimalTypeConfig.kSuperBird]
        }
    } else if (guide_type == GUIDE_TYPE.SWAP_5X4) {
        if (mainLogic.swapSpecialItemList) num = mainLogic.swapSpecialItemList["5x4"]
    } else if (guide_type == GUIDE_TYPE.SWAP_4X4) {
        if (mainLogic.swapSpecialItemList) num = mainLogic.swapSpecialItemList["4x4"]
    }
    return num
}

// 检测是否符合显示引导
DynamicGuideLogic.prototype.checkShowGuide = function (mainLogic, maxStep) {
    let self = this
    let moveStepNum = mainLogic.realCostMove
    let guideList = []
    if (!self.isOpen() || this.allCompleteTag || !this.dynamicGuideFlag) return guideList //全部引导做完直接返回空数组
    // if (moveStepNum == 1 || true){//测试代码
    //     guideList = [{
    //         guide_id: 3,
    //         guide_type: 2,
    //         desc: "魔力鸟和特效交换，\n可以获得超强效果！"
    //     }]
    // }
    // 先检查是否引导过
    for (const key in self.use_config) {
        let conf = self.use_config[key]
        if (!this.info.dynamicGuideNum[conf.guide_id] || this.info.dynamicGuideNum[conf.guide_id] == 0) {
            let combineNum = tonumber(this.info.effectCombineNum[conf.guide_id])|| 0
            if (combineNum <= tonumber(conf.times_tag)){
                // 再检查区间段
                let levelTag = conf.levelTag
                if (mainLogic.level >= levelTag[0] && mainLogic.level <= levelTag[1]) {
                    // 再检查步数区间 "max-5"
                    let moveTag = conf.moveTag
                    let move_expression = moveTag[1]
                    move_expression = move_expression.replace("max",maxStep)
                    let moveLimit = simpleEval(move_expression)
                    // cc.log("[DynamicGuide] moveLimit ",move_expression, moveLimit)
                    if (moveStepNum >= moveTag[0] && moveStepNum <= moveLimit) {
                        // guideList.push(conf.guide_type) 
                        guideList.push({
                            guide_id:conf.guide_id,
                            guide_type:conf.guide_type,
                            desc: conf.desc
                        })
                    }else{
                        cc.log(`[DynamicGuide] 引导${key}不在步数段`,conf.moveTag)
                    }
                }else{
                    cc.log(`[DynamicGuide] 引导${key}不在等级段`,conf.levelTag)
                }
            }else{
                cc.log(`[DynamicGuide] 引导${key}不在满足前置条件`,combineNum,conf.times_tag)
            }
        }
    }
    // 返回需要引导的类型
    cc.log("[DynamicGuide] guideList ",guideList)
    return guideList
}

DynamicGuideLogic.prototype.cleanGuide = function () {
    let guideLayer = (cc.Director.getInstance().getRunningScene() || table()).guideLayer || cc.Layer.create()
    if (guideLayer.getChildrenCount() > 0) {
        guideLayer.removeAllChildren()
    }
}
module.exports = DynamicGuideLogic